import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import { authReducer } from '@shared/api/reduxToolkit';
import { AUTH_KEY } from '@shared/constants';

const authPersistConfig = {
	key: AUTH_KEY,
	version: 1,
	storage: storageSession,

	whitelist: ['refreshToken'],
};

export const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
